module.exports = __webpack_public_path__ + "img/margot-wagner.31f66e0a.jpg";